import { Union, Record } from "../../../../src/fable_modules/fable-library.3.7.18/Types.js";
import { union_type, option_type, list_type, record_type, string_type, class_type } from "../../../../src/fable_modules/fable-library.3.7.18/Reflection.js";
import { tryPick, tryFind, toArray, ofArray, map } from "../../../../src/fable_modules/fable-library.3.7.18/List.js";
import { newGuid } from "../../../../src/fable_modules/fable-library.3.7.18/Guid.js";
import { printf, toText } from "../../../../src/fable_modules/fable-library.3.7.18/String.js";
import { useFeliz_React__React_useElmish_Static_Z151674B } from "../../../../src/fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";
import { ProgramModule_mkSimple } from "../../../../src/fable_modules/Fable.Elmish.4.0.0-beta-3/program.fs.js";
import { MuiHelpers_createElement } from "../../../../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Typography, TextField, Autocomplete as Autocomplete_1 } from "@mui/material";
import { singleton, append, delay, toList } from "../../../../src/fable_modules/fable-library.3.7.18/Seq.js";
import { Browser_Types_Event__Event_get_Value } from "../../../../../src/Feliz.MaterialUI/../../docs-app/src/fable_modules/Fable.React.8.0.1/Fable.React.Extensions.fs.js";
import { defaultArg, bind } from "../../../../src/fable_modules/fable-library.3.7.18/Option.js";
import { Interop_reactApi } from "../../../../src/fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { createElement } from "react";

export class Country extends Record {
    constructor(Id, Name, Description) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
    }
}

export function Country$reflection() {
    return record_type("Samples.Components.Autocomplete.Autocomplete.Country", [], Country, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Description", string_type]]);
}

export class Model extends Record {
    constructor(Countries, MyText, LastSelected) {
        super();
        this.Countries = Countries;
        this.MyText = MyText;
        this.LastSelected = LastSelected;
    }
}

export function Model$reflection() {
    return record_type("Samples.Components.Autocomplete.Autocomplete.Model", [], Model, () => [["Countries", list_type(Country$reflection())], ["MyText", string_type], ["LastSelected", option_type(class_type("System.Guid"))]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetText", "Select"];
    }
}

export function Msg$reflection() {
    return union_type("Samples.Components.Autocomplete.Autocomplete.Msg", [], Msg, () => [[["Item", string_type]], [["Item", option_type(class_type("System.Guid"))]]]);
}

export const init = new Model(map((s) => (new Country(newGuid(), s, toText(printf("Description of %s"))(s))), ofArray(["Afghanistan", "Aland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan"])), "", void 0);

export function update(msg, m) {
    if (msg.tag === 1) {
        return new Model(m.Countries, m.MyText, msg.fields[0]);
    }
    else {
        return new Model(m.Countries, msg.fields[0], m.LastSelected);
    }
}

export function Autocomplete(autocompleteInputProps) {
    let options, children;
    const patternInput = useFeliz_React__React_useElmish_Static_Z151674B(() => ProgramModule_mkSimple(() => init, update, (_arg, _arg_1) => {
    }), [autocompleteInputProps.$key]);
    const state = patternInput[0];
    const dispatch = patternInput[1];
    const children_1 = ofArray([MuiHelpers_createElement(Autocomplete_1, [(options = toArray(state.Countries), ["options", Array.from(options)]), ["getOptionLabel", (c) => c.Name], ["freeSolo", true], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["value", state.MyText]), delay(() => append(singleton(["onChange", (e) => {
        dispatch(new Msg(0, Browser_Types_Event__Event_get_Value(e)));
    }]), delay(() => append(singleton(["fullWidth", true]), delay(() => singleton(["style", {
        width: 300,
    }]))))))))))))], ["value", bind((cid) => tryFind((c_1) => (c_1.Id === cid), state.Countries), state.LastSelected)], ["onChange", (_arg_2, v, _arg_1_1) => {
        dispatch(new Msg(1, v.Id));
    }]]), (children = ofArray(["Last selected: ", defaultArg(bind((cid_1) => tryPick((c_3) => {
        if (c_3.Id === cid_1) {
            return c_3.Name;
        }
        else {
            return void 0;
        }
    }, state.Countries), state.LastSelected), "None")]), MuiHelpers_createElement(Typography, [["children", Interop_reactApi.Children.toArray(Array.from(children))]]))]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    });
}

